export const postLoadEditConfirmationMessage =
  'Are you sure you want to edit this load?' +
  '<br/><br/>' +
  'It will be removed from the Marketplace and need to be reposted after saving.';

export const autoApproveCounterOfferMessage =
  'Counter offers will be automatically accepted if Rate Seeker step rate exceeds carriers counter offer.';
